import {
  useGetCommitteeMembersQuery,
  useGetMemberSummaryQuery,
  useGetTeamCompetitionsQuery,
  teamCompetitionSelectors,
} from '../state/api';
import { selectMemberEntities } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import { createMemberLookupFromArray } from '../utils/committee';
import Committee from './committee';

const CommitteeContainer = () => {
  const { data: committeeMembersData } = useGetCommitteeMembersQuery();
  const committeeMembers = committeeMembersData || [];

  useGetMemberSummaryQuery();
  const memberEntities = useAppSelector(selectMemberEntities);
  const memberLookup = createMemberLookupFromArray(Object.values(memberEntities));

  const { data: teamCompetitionsState } = useGetTeamCompetitionsQuery({ withCompetitors: true });
  const teamCompetitions = teamCompetitionsState ? teamCompetitionSelectors.selectAll(teamCompetitionsState) : [];

  return (
    <Committee
      committeeMembers={committeeMembers}
      memberLookup={memberLookup}
      memberSummaries={Object.values(memberEntities)}
      teamCompetitions={teamCompetitions}
    />
  );
};

export default CommitteeContainer;
